import { connect, ConnectedProps } from 'react-redux';
import { AppState } from '../../interfaces';
import { API_KEYS } from '../../interfaces/api';
import { getApiState } from '../../redux/selectors/common';
import { hideModal, showModal } from '../../redux/slices/modal';
import { resetApiThunk } from '../../redux/thunks/api';
import { thunks } from '../../redux/thunks/thunks';
import Withdraw from './Withdraw';

const mapState = (state: AppState) => ({
  walletTransactions: getApiState(
    state,
    API_KEYS.WALLET_TRANSACTIONS_SHIPMENT_HISTORY
  ),
  getBankState : getApiState(state, API_KEYS.GET_COD_BANKS),
  bankValidationState : getApiState(state, API_KEYS.VALIDATE_BANK),
  walletPinState : getApiState(state, API_KEYS.GET_WALLETPIN_STATUS),
  resetApi: resetApiThunk,
});

const mapDispatch = {
  showModal,
  hideModal,
  getWalletHistory: thunks.WALLET_TRANSACTIONS_SHIPMENT_HISTORY,
  getBanks : thunks.GET_COD_BANKS,
  validateBankDetails : thunks.VALIDATE_BANK,
  getWalletPinStatus: thunks.GET_WALLETPIN_STATUS
};

const connector = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(Withdraw);
